import fs from 'fs'
import path from 'path'

// The CLI runs from two places with different depths — bundled at `dist/index.js`, and straight from
// `src/**` via tsx when `bin/flowrunner.js` finds the TypeScript entry (dev mode / npm link). Neither a
// fixed `../` count nor `process.cwd()` (the *target* project) locates the shipped `templates/` folder, so
// walk up to the package that owns this file.

const PACKAGE_NAME = 'flowrunner-cli'

let cached: string | null = null

function findPackageRoot(): string {
  let dir = __dirname

  while (true) {
    const manifest = path.join(dir, 'package.json')

    if (fs.existsSync(manifest)) {
      try {
        if (JSON.parse(fs.readFileSync(manifest, 'utf-8')).name === PACKAGE_NAME) {
          return dir
        }
      } catch {
        // A malformed package.json on the way up is not ours to complain about — keep walking.
      }
    }

    const parent = path.dirname(dir)

    if (parent === dir) {
      throw new Error(`Could not locate the "${ PACKAGE_NAME }" package root above ${ __dirname }`)
    }

    dir = parent
  }
}

export function packageRoot(): string {
  cached ??= findPackageRoot()

  return cached
}

/** Absolute path of the shipped template content (`packages/cli/templates`). */
export function templatesRoot(): string {
  return path.join(packageRoot(), 'templates')
}
